import {
  CreateSpreadsheetReq,
  ListResp,
  SheetSummaryEntity,
  SpreadsheetEntity,
  SpreadsheetSummaryEntity,
  UpdateUserSpreadsheetReq,
} from 'core/models';
import { SheetDetailResp } from 'core/models/resp/spreadsheets.resp';
import { inject, injectable } from 'inversify';
import { HighlightSpanKind } from 'typescript';
import { HttpClientService } from './http-client.service';

const API_BASE = '/api';

@injectable()
export class SpreadsheetsService {
  @inject(HttpClientService)
  private httpClient: HttpClientService;

  public createSpreadsheet(params: CreateSpreadsheetReq): Promise<void> {
    return this.httpClient.post(API_BASE + '/v1/spreadsheets', params);
  }

  public getSpreadsheetSummaries(offset: number, pageSize: number): Promise<ListResp<SpreadsheetSummaryEntity>> {
    return this.httpClient.get(API_BASE + '/v1/spreadsheets', { offset, pageSize });
  }

  public getSpreadsheetDetailById(id: string): Promise<SpreadsheetEntity> {
    return this.httpClient.get(API_BASE + '/v1/spreadsheets/' + id);
  }

  public updateUserSpreadsheet(params: UpdateUserSpreadsheetReq): Promise<void> {
    const id = params.id;
    delete params.id;
    return this.httpClient.put(API_BASE + '/v1/spreadsheets/' + id, params);
  }

  public getSheetSummaries(spreadsheetId: string, offset: number, pageSize: number): Promise<ListResp<SheetSummaryEntity>> {
    return this.httpClient.get(API_BASE + '/v1/spreadsheets/' + spreadsheetId + '/sheets', { offset, pageSize });
  }

  public getSheetDetail(sheetId: string): Promise<SheetDetailResp> {
    return this.httpClient.get(API_BASE + '/v1/spreadsheets/sheets/' + sheetId);
  }
}
